import {
	SIDEBAR_ASSET_NAME_SET,
	SIDEBAR_EDIT_OPEN_TRADE,
	SIDEBAR_IS_OPEN,
	SIDEBAR_TYPE_SET
} from './actions'
import { LOGOUT } from '../user/actions'

const initialState = {
	sidebarAssetName: '',
	sidebarIsOpen: false,
	sidebarType: '',
	toEditOpenTrade: ''
}

export default (state = initialState, action) => {
	switch (action.type) {
	case LOGOUT: {
		return {
			...initialState
		}
	}
	case SIDEBAR_IS_OPEN: {
		return {
			...state,
			sidebarIsOpen: action.payload
		}
	}
	case SIDEBAR_TYPE_SET: {
		return {
			...state,
			sidebarType: action.payload
		}
	}

	case SIDEBAR_EDIT_OPEN_TRADE: {
		return {
			...state,
			toEditOpenTrade: action.payload
		}
	}
	case SIDEBAR_ASSET_NAME_SET: {
		return {
			...state,
			sidebarAssetName: action.payload
		}
	}

	default: {
		return state
	}
	}
}
